import { wrapRetry } from '@perpay-web/utils/importUtils';

export const importPerpayPlusSoloCheckoutContainer = () =>
    wrapRetry(
        () =>
            import(
                /* webpackChunkName: "PerpayPlusSoloCheckoutContainer" */
                '@perpay-web/fintech/components/containers/PerpayPlusSoloCheckoutContainer'
            ),
    );
